import { render, staticRenderFns } from "./SignUpBox.vue?vue&type=template&id=f9ca5ca2&"
import script from "./SignUpBox.vue?vue&type=script&lang=js&"
export * from "./SignUpBox.vue?vue&type=script&lang=js&"
import style0 from "./SignUpBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports